import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_invoice_miscellaneous_list = (query) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.INV_MIS_LIST}/getbycompanyanddepartment`,
        query
    );
};
export const billing_expense_getInvMiscellaneousByCom_Dep = (query) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.INV_MIS_LIST}` + `/getbycompanyanddepartment`,
        query
    );
};

export const billing_expense_getInvMiscellaneousByCom_Dep_Pagination = (
    page,
    limit,
    sortBy,
    sortOrder,
    company_id,
    department_id,
    title
) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.INV_MIS_LIST}/getbycompanyanddepartment-pagination`,
        {
            params: {
                page,
                limit,
                sortBy,
                sortOrder,
                company_id,
                department_id,
                title,
            },
        }
    );
};

export const billing_expense_addInvMiscellaneous = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.INV_MIS_LIST}`, data);
};

export const billing_expense_getInvMiscellaneousByID = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INV_MIS_LIST}` + `/get-by-id/${id}`);
};

export const billing_expense_UpdateInvMiscellaneous = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.INV_MIS_LIST}` + `/${id}`, data);
};

export const billing_expense_DeleteInvMiscellaneous = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.INV_MIS_LIST}` + `/${id}`);
};